import './index.scss'
$(".section7 ul li").click(function() {
    $(this).find(".text").slideToggle();
    $(this).toggleClass("active");
})